import React from "react";

const FleetListItem = ({ vessel }) => {
  return (
    <div className="fleet-list-item">
      <div className="list-item-inner">
        <div className="item-col">
          <span className="fleet-list-category">VERTOM</span>{" "}
          <span className="text-gray">(OPERATOR)</span>
          <h3 className="list-item-title">{vessel.title.rendered}</h3>
        </div>

        <div className="item-col">
          <div className="vessel-spec-inner">
            <span className="spec-gray">Built</span>
            <span className="spec-bold">{vessel.acf.built}</span>
          </div>
        </div>

        <div className="item-col">
          <div className="vessel-spec-inner">
            <span className="spec-gray">DWAT</span>
            <span className="spec-bold">{vessel.acf.dwat}</span>
          </div>
        </div>

        <div className="item-col">
          <div className="vessel-spec-inner">
            <span className="spec-gray">Capacity</span>
            <span className="spec-bold">{vessel.acf.capacity}</span>
          </div>
        </div>

        <div className="item-col">
          <div className="vessel-spec-inner">
            <span className="spec-gray">Geared</span>
            <span className="spec-bold">{vessel.acf.geared}</span>
          </div>
        </div>

        <div className="item-col">
          <a className="more-info-btn" href={vessel.link} target="_parent">
            More info
          </a>
          <a
            className="downloads-specs-btn"
            target="_blank"
            rel="noreferrer"
            href={vessel.acf.download_specs}
          >
            Download specs <i className="fa-solid fa-cloud-arrow-down"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FleetListItem;
